import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65ad8970"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 px-0" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon mr-2 icon-settings_profil_verwalten",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "row mx-auto mt-4 mb-4"
}
const _hoisted_6 = { class: "col-12 font-weight-bold px-0 mb-3" }
const _hoisted_7 = { class: "col-12 admin-delete-checkboxes mb-2" }
const _hoisted_8 = { class: "col-12 col-md-4 offset-md-2 col-lg-3 offset-lg-3 mt-1 px-xs-0" }
const _hoisted_9 = { class: "col-12 col-md-4 col-lg-3 mt-1 px-xs-0" }
const _hoisted_10 = { class: "row mx-auto mt-4" }
const _hoisted_11 = {
  key: 0,
  class: "col-12 col-md-4 offset-md-2 col-lg-3 offset-lg-3 mt-1 px-xs-0"
}
const _hoisted_12 = { class: "col-12 col-md-4 col-lg-3 mt-1 px-xs-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_back = _resolveComponent("button-back")!
  const _component_control_checkboxes = _resolveComponent("control-checkboxes")!
  const _component_button_cancel = _resolveComponent("button-cancel")!
  const _component_button_delete = _resolveComponent("button-delete")!
  const _component_control_select = _resolveComponent("control-select")!
  const _component_control_input = _resolveComponent("control-input")!
  const _component_control_checkbox = _resolveComponent("control-checkbox")!
  const _component_button_save = _resolveComponent("button-save")!
  const _component_loading_container = _resolveComponent("loading-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('views.reservationEdit.title')), 1)
      ])
    ]),
    _createVNode(_component_button_back, {
      onClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.back()))
    }),
    _createVNode(_component_loading_container, {
      state: _ctx.state,
      errorLinkTo: "/reservations"
    }, {
      default: _withCtx(() => [
        _createElementVNode("dl", null, [
          _createElementVNode("dt", null, _toDisplayString(_ctx.$t('common.ticketTime')), 1),
          _createElementVNode("dd", null, _toDisplayString(_ctx.ticketTime()), 1),
          _createElementVNode("dt", null, _toDisplayString(_ctx.$t('views.reservationEdit.status')), 1),
          _createElementVNode("dd", null, _toDisplayString(_ctx.$t('common.ticketTypeSingle.' + _ctx.ticket.status)), 1)
        ]),
        (_ctx.showDeleteConfirmation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$tc('views.reservationEdit.confirmDelete', { count: _ctx.relatedTicketsAvailable().length + 1, msg: _ctx.surName + ' ' + _ctx.givenName})), 1),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_control_checkboxes, {
                  available: _ctx.relatedTicketsAvailable(),
                  modelValue: _ctx.relatedTicketsSelected,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.relatedTicketsSelected) = $event))
                }, null, 8, ["available", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_button_cancel, {
                  onClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDeleteConfirmation = false)),
                  class: "btn-w-100"
                })
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_button_delete, {
                  i18nMessage: "common.ticketCancel",
                  onClicked: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cancelTickets())),
                  class: "btn-w-100"
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.showDeleteConfirmation)
          ? (_openBlock(), _createElementBlock("form", {
              key: 1,
              onSubmit: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.onSubmit()), ["prevent"]))
            }, [
              _createVNode(_component_control_select, {
                i18nLabel: "common.owner.salutation",
                validation: _ctx.v$.salutation,
                modelValue: _ctx.salutation,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.salutation) = $event)),
                availableValues: _ctx.salutationOptions()
              }, null, 8, ["validation", "modelValue", "availableValues"]),
              _createVNode(_component_control_input, {
                i18nLabel: "common.owner.title",
                validation: _ctx.v$.title,
                modelValue: _ctx.title,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.title) = $event))
              }, null, 8, ["validation", "modelValue"]),
              _createVNode(_component_control_input, {
                i18nLabel: "common.owner.givenName",
                validation: _ctx.v$.givenName,
                modelValue: _ctx.givenName,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.givenName) = $event))
              }, null, 8, ["validation", "modelValue"]),
              _createVNode(_component_control_input, {
                i18nLabel: "common.owner.surName",
                validation: _ctx.v$.surName,
                modelValue: _ctx.surName,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.surName) = $event))
              }, null, 8, ["validation", "modelValue"]),
              _createVNode(_component_control_input, {
                i18nLabel: "common.owner.organization",
                validation: _ctx.v$.organization,
                modelValue: _ctx.organization,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.organization) = $event))
              }, null, 8, ["validation", "modelValue"]),
              _createVNode(_component_control_input, {
                i18nLabel: "common.owner.email",
                validation: _ctx.v$.email,
                modelValue: _ctx.email,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.email) = $event)),
                type: "email"
              }, null, 8, ["validation", "modelValue"]),
              _createVNode(_component_control_input, {
                i18nLabel: "common.owner.phone",
                validation: _ctx.v$.phone,
                modelValue: _ctx.phone,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.phone) = $event)),
                type: "tel"
              }, null, 8, ["validation", "modelValue"]),
              _createVNode(_component_control_checkbox, {
                i18nLabel: "common.owner.accessible",
                validation: _ctx.v$.accessible,
                modelValue: _ctx.accessible,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.accessible) = $event))
              }, null, 8, ["validation", "modelValue"]),
              _createElementVNode("div", _hoisted_10, [
                (_ctx.ticket.cancelable)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(_component_button_delete, {
                        i18nMessage: "common.ticketCancel",
                        onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.showDeleteConfirmation = true), ["prevent"])),
                        class: "btn-w-100"
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_button_save, {
                    onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.saveTicket()), ["prevent"])),
                    class: "btn-w-100"
                  })
                ])
              ])
            ], 32))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["state"])
  ]))
}